import * as React from "react";
import SongCard from './SongCard';
import InfiniteScroll from 'react-infinite-scroller';
import CircularProgressIndicator from '../common/CircularProgressIndicator';


interface ISongCardListScrollProps
{
    loadMoreItems(page : number, pageSize : number) : Promise<any>,
    pageSize: number,
    type: string,
    upVote (id : string),
    downVote (id : string)
}

class SongCardListScroll extends React.Component<ISongCardListScrollProps, any> {

    //noinspection JSUnusedGlobalSymbols
    static defaultProps = {
        pageSize: 50
    };

    constructor(props : ISongCardListScrollProps) {
        super(props);

        this.state = {
            songs: [],
            hasMore: true
        };

        this.handleLoadMore = this.handleLoadMore.bind(this);
    }

    async handleLoadMore(page) {

        console.log(`load page ${page}`);
        const newItems = await this.props.loadMoreItems(page, this.props.pageSize);
        console.log(`got ${newItems.length} new items`);

        const hasMore = newItems.length === this.props.pageSize;
        console.log(`has more '${hasMore}'; page size ${this.props.pageSize}`);

        const totalSongsList = this.state.songs;

        newItems.map(eachNewSong => {
            totalSongsList.push(eachNewSong);
        });

        this.setState({
            songs: totalSongsList,
            hasMore: hasMore
        });
    }

    render() {

        const songsCard = this.state.songs.map(eachSong =>
            <SongCard key={eachSong.id}
                      song={eachSong}
                      type={this.props.type}
                      upVote={this.props.upVote}
                      downVote={this.props.downVote}
            />);

        return (
            <div>
                <InfiniteScroll
                    loadMore={this.handleLoadMore}
                    pageStart={-1}
                    threshold={1000}
                    useWindow={true}
                    hasMore={this.state.hasMore}
                    loader={<CircularProgressIndicator/>}
                >
                    {songsCard}
                </InfiniteScroll>
            </div>
        );
    }

}

export default SongCardListScroll;


// WEBPACK FOOTER //
// ./components/songs/SongCardListScroll.tsx